<div class="body">
  <div class="container">
    <div class="row">
      <div class="col-sm-12 center">
        <img [src]="brand.loginLogo" [alt]="brand.brandName" class="logo-image" [style.width]="brand.loginLogoWidth" [style.margin-bottom]="brand.loginLogoMarginBottom">
      </div>
      <div class="col-sm-12 input-container-box">
        <form [formGroup]="loginForm" (ngSubmit)="onSubmit()">
          <div class="form-group input-container">
            <input type="text" formControlName="username" class="form-control input-field"
              [ngClass]="{ 'is-invalid': submitted && f.username.errors }" placeholder="Username">
            <div *ngIf="submitted && f.username.errors" class="invalid-feedback">
              <div *ngIf="f.username.errors.required">Username is required</div>
            </div>
            
          </div>
          <div class="form-group input-container">
            <input formControlName="password" [type]="showPassword ? 'text' : 'password'"
              class="form-control input-field" [ngClass]="{ 'is-invalid': submitted && f.password.errors }"
              placeholder="Password" />
            <div *ngIf="submitted && f.password.errors" class="invalid-feedback">
              <div *ngIf="f.password.errors.required">Password is required</div>
            </div>
            <div>
              <mat-checkbox class="showPass" (change)="togglePasswordVisibility()">Show Password</mat-checkbox>
            </div>
          </div>
          <div class="form-group input-container">
            <button [disabled]="loginForm.invalid || loading" [class.disabled]="loginForm.invalid || loading" class="btn btn-primary log-btn">Login</button>
          </div>
          <div *ngIf="error" class="alert alert-danger">{{error}}</div>
          <div class="button-container center">
            <a class="small-txt" [routerLink]="['/forgot-password']">Forgot Password? </a>
          </div>
        </form>
      </div>
    </div>
  </div>
</div>
<div *ngIf="licenseExpiredMessage" class="license-expired">
  {{ licenseExpiredMessage }}
</div>